import { Box, Divider, Grid, Skeleton, Stack } from "@mui/material";
import DiagnosisForm from "./components/diagnosisForm";
import { useEncounter } from "pages/encounter/encounter.provider";
import { useEffect } from "react";
const DoctorView = () => {
    const { loading, setDefaultOverwriteIcd10 } = useEncounter();

    useEffect(() => {
        return () => {
            setDefaultOverwriteIcd10();
        };
    }, [setDefaultOverwriteIcd10]);

    if (loading) {
        return (
            <Stack width="100%" spacing={2}>
                <Stack sx={{ height: "45vh" }}>
                    <Skeleton width="100%" height={60} />
                    <Skeleton width="100%" height={60} />
                    <Skeleton width="100%" height={60} />
                    <Skeleton width="100%" height={60} />
                    <Skeleton width="100%" height={60} />
                </Stack>

                <Divider />

                <Skeleton width="100%" height={40} />
            </Stack>
        );
    }

    return (
        <Stack width="100%">
            <Box>
                <Grid container spacing={1}>
                    <DiagnosisForm name="diagnosis.principal" />
                    <DiagnosisForm name="diagnosis.comorbidity" />
                    <DiagnosisForm name="diagnosis.complication" />
                    <DiagnosisForm name="diagnosis.other" />
                    <DiagnosisForm name="diagnosis.externalCause" />
                </Grid>
            </Box>
        </Stack>
    );
};

export default DoctorView;
